import dayjs from 'dayjs';

export function getMonthDays(month: number = dayjs().month()): Date[][] {
  const year: number = dayjs().year();
  const firstDayOfTheMonth: dayjs.Dayjs = dayjs(new Date(year, month, 1));
  const firstDayOfMonthIndex: number = firstDayOfTheMonth.day();
  let currentMonthCount: number = 1 - firstDayOfMonthIndex;

  const daysMatrix: Date[][] = new Array(6).fill([]).map(() => {
    return new Array(7).fill(null).map(() => {
      const currentDate: Date = dayjs(new Date(year, month, currentMonthCount)).toDate();
      currentMonthCount++;
      return currentDate;
    });
  });

  return daysMatrix;
}

export function getNowMonth(): number {
  const month: number = dayjs().month();
  return month;
}

export function getMonth(month: number = dayjs().month()): Date {
  const year: number = dayjs().year();
  const firstDayOfTheMonth: Date = dayjs(new Date(year, month, 1)).toDate();
  return firstDayOfTheMonth;
}

export function getCurrentFiscalYear(date:Date = new Date()):number {
  const year = date.getFullYear();
  const month = date.getMonth();
  return month >= 3 ? year : year - 1;
}

export function convertStr(date: Date, format: string): string {
  const dateString = dayjs(date).format(format);
  return dateString;
}

export function incrementDate(date: Date, add: number): Date {
  const yesterday = new Date(date);
  yesterday.setDate(date.getDate() - 1);
  return yesterday;
}

/**
 * 少数を指定位置で四捨五入 (画面上に少数を表示する場合はこの関数の戻り値を使用すること)
 * @param {number} num 対象の数値
 * @param {number} [roundDigit=1] 丸め桁位置 デフォルトで少数第一位を四捨五入
 */
export function roundNumber(num: number, roundDigit: number = 1) {
  const accuracy = Math.pow(10, Math.round(roundDigit) - 1);
  return Number((Math.round(num * accuracy) / accuracy).toFixed(roundDigit - 1));
}

/**
 * 少数を指定位置で切り上げ (画面上に少数を表示する場合はこの関数の戻り値を使用すること)
 * @param {number} num 対象の数値
 * @param {number} [ceilDigit=1] 丸め桁位置 デフォルトで少数第一位を切り上げ
 */
export function ceilNumber(num: number, ceilDigit: number = 1) {
  const accuracy = Math.pow(10, Math.round(ceilDigit) - 1);
  return Number((Math.ceil(num * accuracy) / accuracy).toFixed(ceilDigit - 1));
}

/** ゼロ埋めされていない文字列をISO文字列に変換 */
export function toISODateStr(dateStr?: string | Date) {
  if (!dateStr) {
    return '';
  }
  if (dateStr instanceof Date) {
    dateStr.setHours(9);
    dateStr = dateStr.toISOString();
  }

  const [year, month, day] = (dateStr || '').split(/\/|-|T/);
  return new Date(Number(year), Number(month) - 1, Number(day), 9).toISOString().split('T').shift() || '';
}

/** 数値のプロパティはnumber型に変換 */
export function toNumberProps(value: any): any {
  if (typeof value === 'object') {
    Object.keys(value || {}).forEach((key) => {
      const v = (value as any)[key];
      (value as any)[key] = toNumberProps(v);
    });

    return value;
  } else {
    const toNum = (v: any) => (Array.isArray(v) ? v.map((vv: any) => toNumberProps(vv)) : !/[0-9]/.test(v) || isNaN(Number(v)) ? v : Number(v));
    return Array.isArray(value) ? value.map((v: any) => toNum(v)) : toNum(value);
  }
}
